import React from 'react';

import { useTranslation } from 'react-i18next';

import { CustomModal, Flex, Popup, UiButton, UiText } from '@shared/ui';

import cls from './ModalEditManagerInfo.module.css';
import { useModalEditManagerInfo } from './useModalEditManagerInfo';
import { Loader } from '../../../../components/UI/NewLoader/Loader/Loader';
import { ModalBodyAddManagerInfo } from '../ModalAddManagerInfo/ModalBodyAddManagerInfo/ModalBodyAddManagerInfo';

interface ModalEditManagerInfoProps {
    classes?: string;
}

export const ModalEditManagerInfo = ({ classes }: ModalEditManagerInfoProps) => {
    const {
        modalMode,
        form,
        onForm,
        onCancel,
        errorsMessage,
        onSubmit,
        openSecondModal,
        onCancelSecondModal,
        clearFormData,
        modalLoader,
    } = useModalEditManagerInfo();

    const { t } = useTranslation();

    return (
        <>
            <Popup
                isOpen={openSecondModal}
                onHidePopup={onCancelSecondModal}
                btnActionCb={clearFormData}
                type="delete"
                deleteButtonText={t('ModalEditManagerInfo.return.popup.danger')}
                cancelButtonText={t('ModalEditManagerInfo.return.popup.cancel')}
                popupContentClassName={cls.secondModal}
                contentText=" "
            >
                <div className={cls.ModalTextBlock}>
                    <span>{t('ModalEditManagerInfo.return.popup.text.part1')}</span>
                    <br />
                    <span>{t('ModalEditManagerInfo.return.popup.text.part2')}</span>
                </div>
            </Popup>

            <CustomModal
                classes={classes}
                isOpen={modalMode === 'editManagerInfo'}
                onHideModal={onCancel}
            >
                {modalLoader && <Loader variant="light" />}
                <CustomModal.Header classes={cls.modalHeader}>
                    <Flex direction="column" align="start" gap={10}>
                        {t('ModalEditManagerInfo.return.modalHeader')}

                        <div className={cls.subtitle}>
                            <UiText variant="mediumPlain">
                                {t('ModalAddManagerInfo.return.modalHeader.subtitle')}
                            </UiText>
                        </div>
                    </Flex>
                </CustomModal.Header>
                <CustomModal.Body>
                    <ModalBodyAddManagerInfo
                        isEdit
                        form={form}
                        onForm={onForm}
                        errors={errorsMessage}
                    />
                </CustomModal.Body>
                <CustomModal.Footer>
                    <Flex fullWidth justify="between">
                        <UiButton
                            btnColor="secondary"
                            onClick={onCancel}
                            btnText={t('ModalEditManagerInfo.return.modalFooter.cancel')}
                        />
                        <UiButton
                            onClick={onSubmit}
                            btnText={t('ModalEditManagerInfo.return.modalFooter.submit')}
                        />
                    </Flex>
                </CustomModal.Footer>
            </CustomModal>
        </>
    );
};
